import { Row, Typography, Image } from 'antd';
import carCaution from '../../assets/carCaution.png';
import { baseStyle } from '../../shared/styles/baseStyle';

const DeleteCompletionAlert = () => (
  <>
    <Row style={baseStyle.row}>
      <Typography.Text>
        Η Διαγραφή λογαριασμού σου ολοκληρώθηκε.
      </Typography.Text>
    </Row>
    <Row justify="center">
      <Image
        style={{ padding: 20 }}
        src={carCaution}
        width={200}
        preview={false}
      />
    </Row>
  </>
);
export default DeleteCompletionAlert;
